import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '../context/ThemeContext';

/**
 * Wrapper component that provides theme context for all CMS pages
 * Also ensures CMS pages remain LTR even when RTL language is selected
 */
const CMSWrapper = () => {
    useEffect(() => {
        // Add class to body to force LTR for CMS
        document.body.classList.add('cms-ltr');
        return () => {
            // Remove class when leaving CMS
            document.body.classList.remove('cms-ltr');
        };
    }, []);

    return (
        <div className="cms-ltr">
            <ThemeProvider>
                <Outlet />
            </ThemeProvider>
        </div>
    );
};

export default CMSWrapper;

